export default __webpack_public_path__ + "static/bentoSectionBg3-ce991dbf02887c9089e44e80a85b3d07.webp";